import { useMemo} from 'react'

import { useSpamChecks } from '@app/hooks/useSpamChecks'

import { SpamReport } from './SpamReport'
import { unwrapToHistoryItems } from './helpers'
import { SpamReportProps } from './types'

export const SpamReportContainer = ({ message }: SpamReportProps)=>{
  const {spamChecks, loading} = useSpamChecks(message)
  const historyItems = useMemo(() => unwrapToHistoryItems(spamChecks), [spamChecks])
  return <SpamReport
    isSafe={message.state != 'Spam'}
    loading={loading}
    historyItems={historyItems}
  />
}
